import { useEffect, useState } from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import {
  GridPagination,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector
} from '@mui/x-data-grid';

/**
 * Componente DataGridPagination
 *
 * Paginador personalizado para DataGrid de MUI.
 *
 * @component
 * @param {object} props - Props del componente.
 * @example
 * <DataGridPagination />
 */

type Props = object;

function DataGridPagination(props: Props) {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const [isDesktop, setIsDesktop] = useState<boolean>(window.innerWidth > 880);

  useEffect(() => {
    const mobileMediaQuery = window.matchMedia('(max-width: 1017px)');
    const desktopMediaQuery = window.matchMedia('(min-width: 1018px)');

    const handleMobileChange = (event: MediaQueryListEvent) => {
      if (event.matches) setIsDesktop(false);
    };
    const handleDesktopChange = (event: MediaQueryListEvent) => {
      if (event.matches) setIsDesktop(true);
    };

    mobileMediaQuery.addEventListener('change', handleMobileChange);
    desktopMediaQuery.addEventListener('change', handleDesktopChange);

    return () => {
      mobileMediaQuery.removeEventListener('change', handleMobileChange);
      desktopMediaQuery.removeEventListener('change', handleDesktopChange);
    };
  }, []);

  const handleOnChange = (event: React.ChangeEvent<unknown>, value: number) => {
    apiRef.current.setPage(value - 1);
  };

  return (
    <Stack
      alignItems="center"
      direction="row"
      flexWrap="nowrap"
      justifyContent="space-between"
    >
      <Pagination
        color="primary"
        count={pageCount}
        onChange={handleOnChange}
        page={page + 1}
        siblingCount={isDesktop ? 1 : 0}
        size={isDesktop ? 'medium' : 'small'}
      />
      <GridPagination {...props} />
    </Stack>
  );
}

export default DataGridPagination;
